export default "__VITE_ASSET__C0Vo03us__"